import { Layout, Typography } from '@hub-mono/ui';
import React from 'react';

export const ModalTitleDesc = ({ title, desc }) => {
    return (
        <Layout stack gap="--Spacing-50" hAlign="center" pb={24}>
            <Typography variant="title" size="large">
                {title}
            </Typography>
            <Typography variant="body" size="small" color="neutral20">
                {desc}
            </Typography>
        </Layout>
    );
};
